export default "__VITE_ASSET__CVBNHJOC__"